import AGREGAR_OFICIO_AUTORIZACION_DETALLE from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/agregarOficioAutorizacionDetalles.gql';
import REMOVER_OFICIO_AUTORIZACION_DETALLE from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/removerOficioAutorizacionDetalle.gql';
import OFICIOS_AUTORIZACION from '@/graphql/querys/administracion/programacion/oficiosautorizacion/oficiosautorizacion.gql';

export default {
  methods: {
    // agregar Oficio Autorización Detalle
    async mixAgregarOficioDetalle() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const detalles = [this.detalle];
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OFICIO_AUTORIZACION_DETALLE,
          variables: { detalles },
          update: (store, { data: { agregarOficioAutorizacionDetalles } }) => {
            const query = {
              query: OFICIOS_AUTORIZACION,
            };
            const { oficiosAutorizacion } = store.readQuery(query);
            const index = oficiosAutorizacion
              .findIndex(({ id }) => id === this.oficio.id);
            if (index !== -1) {
              agregarOficioAutorizacionDetalles.forEach((d) => {
                oficiosAutorizacion[index].detalles.push(d);
              });
            }
            store.writeQuery({
              ...query,
              data: {
                oficiosAutorizacion,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarOficioDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OFICIO_AUTORIZACION_DETALLE,
        variables: {
          id: this.oficioAutorizacionDetalleEliminar.id,
        },
        update: (store) => {
          const query = {
            query: OFICIOS_AUTORIZACION,
          };
          const { oficiosAutorizacion } = store.readQuery(query);
          const index = oficiosAutorizacion
            .findIndex(
              (oficio) => oficio.id === this.oficioAutorizacionDetalleEliminar.idOficioAutorizacion,
            );
          if (index !== -1) {
            const indexDetalle = oficiosAutorizacion[index].detalles
              .findIndex((d) => d.id === this.oficioAutorizacionDetalleEliminar.id);
            if (indexDetalle !== -1) {
              oficiosAutorizacion[index].detalles.splice(indexDetalle, 1);
            }
          }
          store.writeQuery({
            ...query,
            data: {
              oficiosAutorizacion,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

  },
};
